import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel, LocationModel } from 'forms/shared/types';
import address from 'forms/shared/validators/models/location/models/address';
import { isPVQForm } from 'helpers/form';
import { DeepSafePartial } from 'types/types';
import { isSafeUnitedStates } from 'helpers/locations';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { PsychologicalAppealTypeModel, PsychologicalOrderTypeModel } from './OrderType';

export const psychologicalAppealTypeValidator: ValidateJSModel<PsychologicalAppealTypeModel> = {
  CourtName: { presence: true, hasValue: true },

  CourtAddress: (value: DeepSafePartial<LocationModel | undefined>, attributes, attributeName, options) => { //
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          requireStreet: isSafeUnitedStates(value),
          validator: pvqLocationModelValidator,
        }
      };
    }

    return {
      presence: true,
      location: {
        validator: address,
        allowPOBox: false,
      }
    };
  },

  Disposition: { presence: true, hasValue: true },

  Comments: {},
};

const psychologicalOrderTypeValidator: ValidateJSModel<PsychologicalOrderTypeModel> = {
  CourtName: { presence: true, hasValue: true },

  CourtAddress: (value: DeepSafePartial<LocationModel | undefined>, attributes, attributeName, options) => { //
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          requireStreet: isSafeUnitedStates(value),
          validator: pvqLocationModelValidator,
        }
      };
    }

    return {
      presence: true,
      location: {
        validator: address,
        allowPOBox: false,
      }
    };
  },

  Disposition: (value, attributes, attributeName, options) => {
    if (options && options.requireDisposition === false) { return {}; }
    return { presence: true, hasValue: true };
  },

  Occurred: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;

    return {
      presence: true,
      date: { requireDay: false, earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    };
  },

  Appeals: {
    presence: true,
    branchCollection: { validator: psychologicalAppealTypeValidator },
  },

  AppealsComments: {},

  AppealsSummaryComments: {},

  Comments: {},
};

export default psychologicalOrderTypeValidator;
